export default {
  routerBase: {
    'a1': '家人',
    'a2': '绑定账号',
    'a3': '新添家人',
    'a4': '编辑家人',
    'a5': '添加记录',
    'a6': '脏音',
    'a7': '步数',
    'a8': 'HRV',
    'a9': '呼吸暂停',
    'a10': '血压',
    'a11': '血糖',
    'a12': '心率',
    'a13': '心电',
    'a14': '心脏负荷',
    'a15': '血氧',
    'a16': '动脉硬化指数',
    'a17': 'sos预警',
    'a18': '健康分析',
    'a19': 'BMI'
  }
}
